import ExcelJS from "exceljs";
import * as fs from "file-saver";
import { apolloClient } from '@/apollo'
import gql from "graphql-tag";

import shortid from 'shortid'
import moment from 'moment'

import { ASYNC_SEARCH } from "@riophae/vue-treeselect";

export function instanceid() {
  return shortid.generate()
}

export function requiredlabel(required, label) {
  for (var prop in required) {
    if (required[prop] == label) {
      return '*' + label
    }
  }
  return label
}

export function dynamicSort(property) {
  let sortOrder = 1;

  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }

  return (a, b) => {
    const result = (a[property] < b[property]) ? -1 : (a[property] > b[property]);

    return result * sortOrder;
  }
}

export function badgeField(row, badge, options) {
  if (!row || !badge.key) return;
  var key = badge.key;
  if (!row.hasOwnProperty([badge.key])) {
    return;
  }
  var value = row[badge.key];
  if (badge.formatter) {
    value = badge.formatter(value, badge.key, row);
  }
  if (!value) {
    return;
  }
  var badge = options.badges.find((k) => k.key == key);
  if (badge) {
    switch (badge.type) {
      case "pill":
        var badgeClass = badge.class;
        var badgeValue = value
          .toString()
          .replace(/^\w/, (c) => c.toUpperCase());
        value =
          "<span " +
          "title='" +
          badgeValue +
          "' " +
          "class='badge badge-" +
          badgeClass +
          " badge-pill'" +
          ">" +
          badgeValue +
          "</span>";
        break;

      case "badge":
        var badgeClass = badge[value];
        if (!badgeClass) {
          badgeClass = badge["other"];
        }
        var badgeValue = value
          .toString()
          .replace(/^\w/, (c) => c.toUpperCase());
        value =
          "<span " +
          "title='" +
          badgeValue +
          "' " +
          "class='badge badge-" +
          badgeClass +
          "'" +
          ">" +
          badgeValue +
          "</span>";
        break;

      case "switch":
        var badgeClass = badge[value];
        var badgeValue = value
          .toString()
          .replace(/^\w/, (c) => c.toUpperCase());
        var checked = "";
        if (value == "enabled") {
          checked = "checked";
        }
        value =
          "<label class='switch-sm switch  switch-label switch-" +
          badgeClass +
          " form-check-label'>" +
          "<input type='checkbox' true-value='" +
          badgeValue +
          "' false-value='no' class='switch-input form-check-input' value='" +
          badgeValue +
          "'" +
          checked +
          ">" +
          "<span class='switch-slider'></span></label>";
        break;

      case "progressbar":
        var badgeClass = badge.class
        console.log(badgeClass)
        var badgeValue = value.toString(); //.substring(0,2)
        if (!badgeClass) {
          badgeClass = "success";
        }
        if (parseFloat(badgeValue) > 100) {
          badgeClass = "danger"
        }
        if (!badge.min) {
          badge.min = 0;
        }
        if (!badge.max) {
          badge.max = 100;
        }
        value =
          "<div role='progressbar' class='progress-bar bg-" +
          badgeClass +
          "'" +
          "aria-valuemin='" +
          badge.min +
          "' " +
          "aria-valuemax='" +
          badge.max +
          "' " +
          "aria-valuenow='" +
          badgeValue +
          "' " +
          "title='" +
          badgeValue +
          "%' " +
          "style='width: " +
          badgeValue +
          "%;'>";
        if (badge.label) {
          value = value + badgeValue;
        }
        value = "</div><div class='progress'>" + value + "</div>";
        break;
    }
  }
  return value;
}

export function actionsValid1(item, actions) {
  var valid = [];
  for (var i = 0; i < actions.length; i++) {
    if (actions[i].rule) {
      var rule = actions[i].rule;
      var op = rule.toString().substring(0, 1);
      var equalTo = true;
      if (op == "!") {
        equalTo = false;
        rule = rule.substring(1);
      }
      if (item) {
        if (item.hasOwnProperty(rule)) {
          var state = item[rule];
          if (
            (state == true && equalTo == true) ||
            (state == false && equalTo == false)
          ) {
            valid.push(actions[i]);
          }
        } else {
          valid.push(actions[i]);
        }
      } else {
        valid.push(actions[i]);
      }
    } else {
      valid.push(actions[i]);
    }
  }
  return valid;
}

export function actionsValid(item, options) {
  var valid = [];
  for (var i = 0; i < options.actions.length; i++) {
    if (options.actions[i].rule) {
      var rule = options.actions[i].rule;
      var op = rule.toString().substring(0, 1);
      var equalTo = true;
      if (op == "!") {
        equalTo = false;
        rule = rule.substring(1);
      }
      if (item.hasOwnProperty(rule)) {
        var state = item[rule];
        if (
          (state == true && equalTo == true) ||
          (state == false && equalTo == false)
        ) {
          valid.push(options.actions[i]);
        }
      } else {
        valid.push(options.actions[i]);
      }
    } else {
      valid.push(options.actions[i]);
    }
  }
  return valid;
}

export function resizableColumns() {
  // RE-SIZE COLUMNS
  var thElm;
  var startOffset;

  Array.prototype.forEach.call(
    document.querySelectorAll("table th"),
    function (th) {
      th.style.position = "relative";

      var grip = document.createElement("div");
      grip.innerHTML = "&nbsp;";
      grip.style.top = 0;
      grip.style.right = 0;
      grip.style.bottom = 0;
      grip.style.width = "5px";
      grip.style.position = "absolute";
      grip.style.cursor = "col-resize";
      grip.addEventListener("mousedown", function (e) {
        thElm = th;
        startOffset = th.offsetWidth - e.pageX;
      });

      th.appendChild(grip);
    }
  );

  document.addEventListener("mousemove", function (e) {
    if (thElm) {
      thElm.style.width = startOffset + e.pageX + "px";
    }
  });

  document.addEventListener("mouseup", function () {
    thElm = undefined;
  });
}

export function mandatoryFields(requirements, row) {
  let message = "";
  for (var prop in requirements) {
    if (row[prop] == null || !row[prop]) {
      message += requirements[prop] + " and ";
    } else if (parseInt(row[prop]) == 0) {
      message += requirements[prop] + " and ";
    }
  }

  if (message.length > 0) {
    message = "<span class='text-danger'>" + message.slice(0, -5) + " are required. </span>";
  }
  return message
}

export async function outputExcel(data) {

  try {
    const response = await apolloClient.query({
      query: gql`
        query setup_report_excel($data: String, $options: String) {
          setup_report_excel(data: $data, options: $options)
        }
      `,
      variables: {
        data: JSON.stringify(data),
        options: JSON.stringify({}),
      },
    });


    let workbook = new ExcelJS.Workbook();
    workbook.model = JSON.parse(response.data.setup_report_excel);
    workbook.created = new Date();
    workbook.modified = new Date();
    let buffer = await workbook.xlsx.writeBuffer();
    fs.saveAs(
      new Blob([buffer], { type: "application/octet-stream" }),
      "data" + moment().format("_YYYYMMDDHHMMSS") + ".xlsx"
    );
  } catch (error) {
    console.log(error);
  }

}

export async function outputTemplate(name) {

  try {
    const response = await apolloClient.query({
      query: gql`
        query templatedownload($name: String) {
          templatedownload(name: $data)
        }
      `,
      variables: {
        name: name
      },
    });

    let workbook = new ExcelJS.Workbook();
    workbook.model = JSON.parse(response.data.templatedownload);
    workbook.created = new Date();
    workbook.modified = new Date();
    let buffer = await workbook.xlsx.writeBuffer();
    fs.saveAs(
      new Blob([buffer], { type: "application/octet-stream" }),
      "template" + moment().format("_YYYYMMDDHHMMSS") + ".xlsx"
    );
  } catch (error) {
    console.log(error);
  }

}

export function breaklines(data) {
  if (data) {
    return data.split("\n").join("<br/>");
  } else {
    return ""
  }
}

export async function loadSLACAttributes(slac) {
  let attributes = ""
  try {
    const response = await apolloClient.query({
      query: gql`
        query clients($slac: String) {
          clients(slac: $slac) {
            attributes
          }
        }
      `,
      variables: { slac },
    });
    console.log(response);
    attributes = response.data.clients[0].attributes;
    if (!attributes) {
      attributes = "";
    }
  } catch (error) {
    console.log(error);
  }
  return attributes
}

export async function loadBLACAttributes(blac) {
  let attributes = ""
  try {
    const response = await apolloClient.query({
      query: gql`
        query suppliers($blac: String) {
          suppliers(blac: $blac) {
            suppliertypeid
          }
        }
      `,
      variables: { blac },
    });
    console.log(response);
    attributes = response.data.suppliers[0].suppliertypeid;
    if (!attributes) {
      attributes = "";
    }
  } catch (error) {
    console.log(error);
  }
  return attributes
}

export async function loadSLAC({ action, searchQuery, callback }) {
  if (action === ASYNC_SEARCH) {
    if (searchQuery.length > 2) {
      let data = [];
      let variables = {
        fuzzy: searchQuery,
      };
      try {
        const response = await this.$apollo.query({
          query: gql`
            query clients($fuzzy: String) {
              clients(fuzzy: $fuzzy) {
                id: slac
                label
              }
            }
          `,
          variables,
        });

        data = response.data.clients;
      } catch (error) {
        console.log(error);
      }
      callback(null, data);
    } else {
      callback(null, []);
    }
  }
}

export async function loadBLAC({ action, searchQuery, callback }) {
  if (action === ASYNC_SEARCH) {
    if (searchQuery.length > 2) {
      let data = [];
      let variables = {
        fuzzy: searchQuery,
      };
      try {
        const response = await this.$apollo.query({
          query: gql`
            query suppliers($fuzzy: String) {
              suppliers(fuzzy: $fuzzy) {
                id: blac
                label
              }
            }
          `,
          variables,
        });

        data = response.data.suppliers;
      } catch (error) {
        console.log(error);
      }
      callback(null, data);
    } else {
      callback(null, []);
    }
  }
}

export async function loadEvents({ action, searchQuery, callback }) {
  if (action === ASYNC_SEARCH) {
    if (searchQuery.length > 2) {
      let data = [];
      let variables = {
        fuzzy: searchQuery,
      };
      try {
        const response = await this.$apollo.query({
          query: gql`
            query events($fuzzy: String) {
              events(fuzzy: $fuzzy) {
               id:eventcode
               label
              }
            }
          `,
          variables,
        });

        data = response.data.events;
      } catch (error) {
        console.log(error);
      }
      callback(null, data);
    } else {
      callback(null, []);
    }
  }
}

export async function loadSalesgroups({ action, searchQuery, callback }) {
  if (action === ASYNC_SEARCH) {
    if (searchQuery.length > 1) {
      let data = [];
      let variables = {
        fuzzy: searchQuery,
      };
      try {
        const response = await this.$apollo.query({
          query: gql`
            query salesgroups($fuzzy: String) {
              salesgroups(fuzzy: $fuzzy) {
               id
               label
              }
            }
          `,
          variables,
        });

        data = response.data.salesgroups;
      } catch (error) {
        console.log(error);
      }
      callback(null, data);
    } else {
      callback(null, []);
    }
  }
}

export async function loadIATA({ action, searchQuery, callback }) {
  if (action === ASYNC_SEARCH) {
    if (searchQuery.length > 2) {
      let data = [];
      let variables = {
        fuzzy: searchQuery,
      };
      try {
        const response = await this.$apollo.query({
          query: gql`
            query setup_airports($fuzzy: String) {
              setup_airports(fuzzy: $fuzzy) {
                id: iata_code
                label
              }
            }
          `,
          variables,
        });

        data = response.data.setup_airports;
      } catch (error) {
        console.log(error);
      }
      callback(null, data);
    } else {
      callback(null, []);
    }
  }
}

export async function getsystemsetting(name) {
  const response = await apolloClient.query({
    query: gql`
      query setup_systemsettings($name: String) {
        setup_systemsettings(name: $name) {
          data
        }
      }
    `,
    variables: { name }
  });
  let result = response.data.setup_systemsettings[0].data;
  return result;
}


export function datefield(field) {
  let result = null
  if (!isNaN(field)) {
    result = moment.unix(field / 1000).utc(true).format("YYYY-MM-DD");
    if (result == "1970-01-01") {
      result = null;
    }
  }
  return result
}
export function datetimefield(field) {
  let result = null
  if (!isNaN(field)) {
    // :ss
    result = moment.unix(field / 1000).utc(true).format("YYYY-MM-DD HH:mm");
    if (result == "1970-01-01 01:00:00") {
      result = null;
    }
  }
  return result
}

export function prepareforSave(e, o) {
  let r = e
  if (Array.isArray(e)) {
    let a = []
    for (var i = 0; i < e.length; i++) {
      r = { ...e[i] }
      for (var prop in r) {
        switch (prop) {
          case "index":
          case "__typename":
          case "_showDetails":
          case "created_by":
          case "created_at":
          case "updated_by":
          case "updated_at":
            delete r[prop]
            break;
        }
      }
      a.push(r)
    }
    r = a
  } else {
    r = { ...e }
    for (var prop in r) {
      switch (prop) {
        case "index":
        case "__typename":
        case "_showDetails":
        case "created_by":
        case "created_at":
        case "updated_by":
        case "updated_at":
          delete r[prop]
          break;
      }
    }
  }
  return r
}

export function getBase64(file) {
  // Returns a promise which gets resolved or rejected based on the reader events
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    // Sets up even listeners BEFORE you call reader.readAsDataURL
    reader.onload = function () {
      let result = reader.result
      if (result) {
        result = result.split("base64,")[1]
      }
      return resolve(result);
    };

    reader.onerror = function (error) {
      return reject(error);
    };
    // Calls reader function
    reader.readAsDataURL(file);
  })
}

export function findPermission(o, id) {
  if (o.id === id) {
    return o;
  }
  var result, p;
  for (p in o) {
    if (o.hasOwnProperty(p) && typeof o[p] === "object") {
      result = findPermission(o[p], id);
      if (result) {
        return result;
      }
    }
  }
  return result;
}

export function tabToObjArr(text) {

  let raw = text.trim().split('"').join("")
  let allcols = raw.split("\t")

  let headers = raw.split("\n")[0].split("\t")
  let cb = headers.length - 1
  let cols = []
  for (let i = 0; i < allcols.length; i++) {
    if (i == cb) {
      let parts = allcols[i].trim().split("\n")
      for (let k = 0; k < parts.length; k++) {
        cols.push(parts[k].trim())
      }
      cb += headers.length - 1
    } else {
      cols.push(allcols[i].trim().split("\n").join(",").replace(/\s+/g, ' '))
    }
  }
  console.log('cols=', cols)

  cb = headers.length - 1
  let rows = []
  let item = {}
  let k = 0
  for (let i = 0; i < cols.length; i++) {
    if (i == cb) {
      item[headers[k]] = cols[i]
      rows.push(item)
      cb += headers.length
      item = {}
      k = 0
    } else {
      item[headers[k]] = cols[i]
      k += 1
    }
  }
  return rows;
}

